module.exports = {
          srcSet: __webpack_public_path__ + "7962273cee88a637ee995a79e7231c53-296.jpg"+" 296w",
          images:[ {path: __webpack_public_path__ + "7962273cee88a637ee995a79e7231c53-296.jpg",width: 296,height: 526}],
          src: __webpack_public_path__ + "7962273cee88a637ee995a79e7231c53-296.jpg",
          toString:function(){return __webpack_public_path__ + "7962273cee88a637ee995a79e7231c53-296.jpg"},
          
          width: 296,
          height: 526
        }